
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHeavyRain as ObiHeavyRainElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-heavy-rain.js';
 
 
 

 
 export const ObiHeavyRain = createComponent({
   react: React,
   tagName: 'obi-heavy-rain',
   elementClass: ObiHeavyRainElement,
   events: {
     
   }
  });
 
 